import type { ApiCommerceOffer } from "@bridge-applications/pb-types";

type ApiCommercePrice = ApiCommerceOffer["prices"][number];

export function telegramStarsPrice(
    offer: Pick<ApiCommerceOffer, "prices">,
): ApiCommercePrice | null {
    return (
        offer.prices.find(
            (price) =>
                price.providerCode === "telegram_stars" &&
                price.paymentCurrencyCode === "XTR",
        ) ?? null
    );
}

export function formatIntegerAmount(amount: string, locale: string): string {
    return BigInt(amount).toLocaleString(locale);
}

export function formatCommercePrice(
    price: ApiCommercePrice,
    locale: string,
): string {
    const amount = formatIntegerAmount(price.unitAmount, locale);
    return price.providerCode === "telegram_stars"
        ? `\u2b50 ${amount}`
        : `${price.paymentCurrencyCode} ${amount}`;
}

export function energyAmountForOffer(offer: ApiCommerceOffer): string | null {
    return (
        offer.rewards.find((reward) => reward.kind === "SM_ENERGY")?.amount ??
        null
    );
}

export function presentationTranslationKey(
    presentation: Record<string, unknown>,
    field: "titleKey" | "descriptionKey",
): string | null {
    const value = presentation[field];
    return typeof value === "string" && value.length > 0 ? value : null;
}

export function remainingCountdown(expiresAt: string, now: number): string {
    const remainingMs = Math.max(0, Date.parse(expiresAt) - now);
    const totalSeconds = Math.ceil(remainingMs / 1_000);
    const days = Math.floor(totalSeconds / 86_400);
    const hours = Math.floor((totalSeconds % 86_400) / 3_600);
    const minutes = Math.floor((totalSeconds % 3_600) / 60);
    const seconds = totalSeconds % 60;

    if (days > 0) {
        return `${days}d ${String(hours).padStart(2, "0")}h`;
    }
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}
